import React from 'react'
import PropTypes from 'prop-types'
import {
  IconFAWrapper,
  ICON_FA_VARIANT_SOLID,
  ICON_FA_VARIANT_REGULAR,
  ICON_FA_VARIANT_LIGHT
} from './IconFAWrapper'

export const IconFAChevronUp = ({
  className,
  variant,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      {variant === ICON_FA_VARIANT_SOLID ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fas'
          data-icon='chevron-up'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z'
          />
        </svg>
      ) : variant === ICON_FA_VARIANT_REGULAR ? (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='far'
          data-icon='chevron-up'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M6.101 359.293L25.9 379.092c4.686 4.686 12.284 4.686 16.971 0L224 198.393l181.13 180.698c4.686 4.686 12.284 4.686 16.971 0l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L232.485 132.908c-4.686-4.686-12.284-4.686-16.971 0L6.101 342.322c-4.687 4.687-4.687 12.285 0 16.971z'
          />
        </svg>
      ) : (
        <svg
          aria-hidden='true'
          focusable='false'
          data-prefix='fal'
          data-icon='chevron-up'
          role='img'
          viewBox='0 0 448 512'
        >
          <path
            shapeRendering='geometricPrecision'
            fill='currentColor'
            d='M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z'
          />
        </svg>
      )}
    </IconFAWrapper>
  )
}

IconFAChevronUp.defaultProps = {
  variant: ICON_FA_VARIANT_REGULAR
}

IconFAChevronUp.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    ICON_FA_VARIANT_SOLID,
    ICON_FA_VARIANT_REGULAR,
    ICON_FA_VARIANT_LIGHT
  ]),
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
